/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliActivityDto } from '../../models/amoxcalli-activity-dto';

export interface ApiActivitiesGet$Plain$Params {
  cycleSubjectId?: string;
  periodId?: string;
  groupId?: string;
}

export function apiActivitiesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiActivitiesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliActivityDto>>> {
  const rb = new RequestBuilder(rootUrl, apiActivitiesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('cycleSubjectId', params.cycleSubjectId, {});
    rb.query('periodId', params.periodId, {});
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliActivityDto>>;
    })
  );
}

apiActivitiesGet$Plain.PATH = '/api/activities';
